(() => {
  const showMedia = (root, mediaId) => {
    if (!mediaId) return;
    const panels = Array.from(root.querySelectorAll('[data-product-media]'));
    if (!panels.some((panel) => panel.dataset.productMedia === mediaId)) return;
    panels.forEach((panel) => {
      const selected = panel.dataset.productMedia === mediaId;
      panel.hidden = !selected;
      if (selected) {
        const image = panel.querySelector('img');
        if (image) image.loading = 'eager';
      }
    });
    root.querySelectorAll('[data-media-target]').forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.mediaTarget === mediaId));
    });
  };

  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-variant-select]');
    const root = select?.closest('[data-variant-media-enabled="true"]');
    if (!root || select.selectedIndex < 0) return;
    const option = select.options[select.selectedIndex];
    showMedia(root, option.dataset.variantMedia);
    const url = new URL(window.location.href);
    url.searchParams.set('variant', select.value);
    window.history.replaceState({}, '', url.toString());
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-media-target]');
    const root = button?.closest('[data-variant-media-enabled="true"]');
    if (root) showMedia(root, button.dataset.mediaTarget);
  });
})();
